






import { Component, Vue } from "vue-property-decorator";
import TheEntryPage from "@/components/TheEntryPage.vue";

@Component({
  components: {
    TheEntryPage,
  },
})
export default class App extends Vue {}
